/**
 * TextContent - 文本内容渲染组件
 */

import React from 'react';

export default function TextContent({ data }) {
  if (!data) return null;

  const hasContent = data.title || data.content;
  const hasBackgroundColor = data.backgroundColor && data.backgroundColor !== '#ffffff';
  const tsTitle = data.titleStyle || {};
  const tsBody = data.contentStyle || {};
  const align = tsBody.align || tsTitle.align; // 若分别设置，以内容为主

  return (
    <div 
      className="label-content-text"
      style={{ backgroundColor: data.backgroundColor || 'transparent', textAlign: align || undefined }}
    >
      {data.title && (
        <div 
          className="text-title"
          style={{ 
            color: data.titleColor,
            fontSize: tsTitle.fontSize || undefined,
            lineHeight: tsTitle.lineHeight || undefined,
            letterSpacing: tsTitle.letterSpacing || undefined,
            textAlign: tsTitle.align || undefined,
            marginBottom: (data.spacing && data.spacing.titleGap) ? data.spacing.titleGap : undefined
          }}
          dangerouslySetInnerHTML={{ __html: data.title }}
        />
      )}
      {data.content && (
        <div 
          className="text-body"
          style={{ 
            color: data.contentColor,
            fontSize: tsBody.fontSize || undefined,
            lineHeight: tsBody.lineHeight || undefined,
            letterSpacing: tsBody.letterSpacing || undefined,
            textAlign: tsBody.align || undefined,
            display: tsBody.paragraphGap ? 'grid' : undefined,
            rowGap: tsBody.paragraphGap || undefined,
            textIndent: tsBody.indent || undefined
          }}
          dangerouslySetInnerHTML={{ __html: data.content }}
        />
      )}
      {!hasContent && hasBackgroundColor && (
        <div className="text-placeholder">背景色预览</div>
      )}
      {!hasContent && !hasBackgroundColor && (
        <div className="text-placeholder">请添加内容</div>
      )}
    </div>
  );
}
